export default __webpack_public_path__ + "static/portfolio-mas-2-c1cfeffb5ed3397653291e597c132212.jpg";